import { Header } from "antd/es/layout/layout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTwitter, faFacebookF, faInstagram, faLinkedinIn, faYoutube, faWhatsapp, faSpotify, faTiktok } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faGlobe, faPhone } from "@fortawesome/free-solid-svg-icons";

function HeaderComponent() {

  const iconStyle = {
    fontSize: '130%',
    color: '#7E0231',
  };

  return (
    <Header className="header">

      {/* ICONS CONTAINER */}
      <div className="header_icons_container">
        <div className="header_icons_container_child">
          <a href="https://www.hospitalsantander.com.mx/" target="_blank" rel="noopener noreferrer">
            <div className="icon_circle_container">
              <FontAwesomeIcon icon={faGlobe} style={iconStyle} />
            </div>
          </a>
          <a href="https://www.facebook.com/HospSantander/" target="_blank" rel="noopener noreferrer">
            <div className="icon_circle_container">
              <FontAwesomeIcon icon={faFacebookF} style={iconStyle} />
            </div>
          </a>
          <a href="https://twitter.com/HospSantander/" target="_blank" rel="noopener noreferrer">
            <div className="icon_circle_container">
              <FontAwesomeIcon icon={faTwitter} style={iconStyle} />
            </div>
          </a>
          <a href="https://www.instagram.com/hospsantander/" target="_blank" rel="noopener noreferrer">
            <div className="icon_circle_container">
              <FontAwesomeIcon icon={faInstagram} style={iconStyle} />
            </div>
          </a>
          <a href="https://www.linkedin.com/company/hospital-santander/" target="_blank" rel="noopener noreferrer">
            <div className="icon_circle_container">
              <FontAwesomeIcon icon={faLinkedinIn} style={iconStyle} />
            </div>
          </a>
          <a href="https://www.youtube.com/@HospitalSantander" target="_blank" rel="noopener noreferrer">
            <div className="icon_circle_container">
              <FontAwesomeIcon icon={faYoutube} style={iconStyle} />
            </div>
          </a>
          <a href="https://wa.me/5218999216700" target="_blank" rel="noopener noreferrer">
            <div className="icon_circle_container">
              <FontAwesomeIcon icon={faWhatsapp} style={iconStyle} />
            </div>
          </a>
          <a href="https://spotify.com" target="_blank" rel="noopener noreferrer">
            <div className="icon_circle_container">
              <FontAwesomeIcon icon={faSpotify} style={iconStyle} />
            </div>
          </a>
          <a href="https://www.tiktok.com/@hospitalsantander" target="_blank" rel="noopener noreferrer">
            <div className="icon_circle_container">
              <FontAwesomeIcon icon={faTiktok} style={iconStyle} />
            </div>
          </a>
        </div>
      </div>

      {/* CONTACT INFO */}

      <div className="header_information_container">

        <div className="header_information_container_child">
          <FontAwesomeIcon icon={faEnvelope} /> info@hospitalsantander.com.mx
        </div>
        <div className="header_information_container_child">
          <FontAwesomeIcon icon={faPhone} />  52 899 921 6700
        </div>

      </div>

    </Header>
  );
}

export default HeaderComponent;